$(document).ready(function () {
	$('.cities-container').slideUp();
	$('.region-cities-container .cities-toggle').click(function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$('.cities-container').slideDown();
		} else {
			$(this).addClass('active');
			$('.cities-container').slideUp();
		}
	});
});
